module.exports = __webpack_public_path__ + "static/hoomvi-51bdf7bbfc3632b9e0b3b3207514c191.png";